import React, { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

// REDUX
import {
	consultaCnhDefinitivaClear,
	consultaCnhDefinitivaRequest,
} from 'store/modules/api/detranCnh/cnhDefinitiva/consultaCnhDefinitiva/actions';
import {
	relatorioAgendamentoMedicoPsicologicoClear,
	relatorioAgendamentoMedicoPsicologicoRequest,
} from 'store/modules/api/detranCnh/agendamentoMedicoPsicologico/relatorio/actions';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import {
	consultaProcessoAbertoClear,
	consultaProcessoAbertoRequest,
} from 'store/modules/api/detranCnh/renachIntegrado/consultaProcessoAberto/actions';
import { ConsultaRenovacaoRequest } from 'store/modules/api/detranCnh/eportal/consultaRenovacaoCnh/types';
import { eventoInicioSessaoRequest } from 'store/modules/api/detranCnh/evento/inicioSessao/actions';
import {
	addNotifications,
	clearNotifications,
} from 'store/modules/app/notifications/actions';

// UTILS
import EnumCNH from 'store/modules/api/detranCnh/enum';
import { threatValuesStartSessionEventRequest } from 'utils/functions/threatEventsRequest';
import { treatAgendamentoMedicoPsicologicoRequestInPesquisar } from 'pages/DetranCnh/utils/threatServicesRequest';

// COMPONENTS
import Pesquisa from 'pages/DetranCnh/components/pages/PreCadastro/Pesquisa';
import ModalProcurador from 'pages/DetranCnh/components/pages/ModalProcurador';

// FORM
import {
	treatValues,
	initialValues,
} from 'pages/DetranCnh/components/pages/PreCadastro/Pesquisa/form';
import { IFormProcurador } from 'pages/DetranCnh/components/pages/ModalProcurador/form';

// PATHS
import { ROUTE_DETRAN_CNH_DEFINITIVA_STATUS_CONDUTOR } from 'pages/DetranCnh/routes/paths';
import { ROUTE_DETRAN_CNH } from 'routes/paths';
import { CONSULTA_CNH_DEFINITIVA_ERROR_RESPONSE_SERVICE_MESSAGE } from 'pages/DetranCnh/utils/constants/serviceResponseMessages';

let valuesRequest: ConsultaRenovacaoRequest = {
	...initialValues,
	senha: '',
	usuario: '',
};

const PesquisaSegundaVia: React.FC = () => {
	const dispatch = useDispatch();
	const history = useHistory();

	const { consultaCnhDefinitiva } = useSelector(
		(state: ApplicationState) => state.api.detranCnh.cnhDefinitiva,
	);

	const { idUsuario, senhaMainFrame } = useSelector(
		(state: ApplicationState) => state.api.sgu.loginUnico.login.mainframe,
	);

	const { relatorio } = useSelector(
		(state: ApplicationState) =>
			state.api.detranCnh.agendamentoMedicoPsicologico,
	);

	const { loginUnico, atendimento } = useSelector(
		(state: ApplicationState) => state.api.sgu,
	);

	const { consultaProcessoAberto } = useSelector(
		(state: ApplicationState) => state.api.detranCnh.renachIntegrado,
	);

	const [modalProcurador, setModalProcurador] = useState('N');
	const [openModalConfirm, setOpenModalConfirm] = useState(false);

	const handleClear = useCallback(() => {
		dispatch(clearNotifications());
		dispatch(consultaCnhDefinitivaClear());
		dispatch(consultaProcessoAbertoClear());
		dispatch(relatorioAgendamentoMedicoPsicologicoClear());
	}, [dispatch]);

	const handleSearchUser = useCallback(
		(values: IFormProcurador) => {
			setModalProcurador(values.flagProcurador);
			dispatch(consultaCnhDefinitivaRequest(valuesRequest));
			setOpenModalConfirm(false);
		},
		[dispatch],
	);

	const handleSubmit = useCallback(
		(values: any) => {
			handleClear();

			valuesRequest = treatValues(values, {
				usuario: idUsuario,
				senha: senhaMainFrame,
			});

			const valuesStartSessionEvent = threatValuesStartSessionEventRequest(
				atendimento,
				loginUnico,
			);

			dispatch(eventoInicioSessaoRequest(valuesStartSessionEvent));
			setOpenModalConfirm(true);
		},
		[atendimento, dispatch, handleClear, idUsuario, loginUnico, senhaMainFrame],
	);

	useEffect(() => {
		if (
			(consultaCnhDefinitiva.status === 200 &&
				consultaCnhDefinitiva.data?.cpf &&
				consultaProcessoAberto.status === 0) ||
			(consultaCnhDefinitiva.status === 400 &&
				consultaCnhDefinitiva.dataError?.mensagem.trim().toLowerCase() ===
					CONSULTA_CNH_DEFINITIVA_ERROR_RESPONSE_SERVICE_MESSAGE.CONDUTOR_PROCESSO_ABERTO.toLowerCase() &&
				consultaCnhDefinitiva.requestData?.cpf &&
				consultaProcessoAberto.status === 0)
		) {
			dispatch(
				consultaProcessoAbertoRequest({
					cpf:
						consultaCnhDefinitiva.data?.cpf ||
						consultaCnhDefinitiva.requestData?.cpf ||
						'',
					ident: 0,
				}),
			);
		}
	}, [
		consultaCnhDefinitiva.data,
		consultaCnhDefinitiva.dataError,
		consultaCnhDefinitiva.requestData,
		consultaCnhDefinitiva.status,
		consultaProcessoAberto.status,
		dispatch,
	]);

	useEffect(() => {
		if (
			(relatorio.data || !relatorio.data) &&
			consultaProcessoAberto.data?.codigoInterno &&
			parseInt(consultaProcessoAberto.data.codigoInterno, 10) !== 0 &&
			consultaProcessoAberto.data?.message
		) {
			addNotifications({
				errors: [consultaProcessoAberto.data.message],
			});
		}
	}, [consultaProcessoAberto.data, dispatch, relatorio.data]);

	useEffect(() => {
		if (
			consultaProcessoAberto.status === 200 &&
			consultaProcessoAberto.data?.codigoInterno &&
			parseInt(consultaProcessoAberto.data.codigoInterno, 10) !== 0 &&
			(consultaProcessoAberto.data.dataExame ||
				consultaProcessoAberto.data.dataExamePsicologo)
		) {
			const requestData = treatAgendamentoMedicoPsicologicoRequestInPesquisar(
				consultaProcessoAberto.data,
			);

			dispatch(relatorioAgendamentoMedicoPsicologicoRequest(requestData));
		} else if (
			consultaProcessoAberto.status === 200 &&
			consultaProcessoAberto.data?.codigoInterno &&
			parseInt(consultaProcessoAberto.data.codigoInterno, 10) === 0
		) {
			history.push({
				pathname: ROUTE_DETRAN_CNH_DEFINITIVA_STATUS_CONDUTOR,
				state: { flagProcurador: modalProcurador },
			});
		}
	}, [
		consultaProcessoAberto.data,
		consultaProcessoAberto.status,
		dispatch,
		history,
		modalProcurador,
	]);

	useEffect(() => {
		handleClear();
	}, [dispatch, handleClear]);

	return (
		<>
			<Pesquisa
				handleSubmit={handleSubmit}
				handleClear={handleClear}
				relatorio={relatorio}
				routeBackButton={ROUTE_DETRAN_CNH}
				specificEnum={EnumCNH.tipoDocumentoEnumSemPGU}
			/>
			<ModalProcurador
				handleSubmit={handleSearchUser}
				modalVisible={openModalConfirm}
				onCancel={() => setOpenModalConfirm(false)}
			/>
		</>
	);
};
export default PesquisaSegundaVia;
